import React, { useEffect, useState } from 'react';
export function CountdownSection({
  isFinal = false
}: {
  isFinal?: boolean;
}) {
  const [timeLeft, setTimeLeft] = useState({
    days: 7,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Set target date 7 days from now
    const targetDate = new Date();
    targetDate.setDate(targetDate.getDate() + 7);
    const interval = setInterval(() => {
      const now = new Date().getTime();
      const distance = targetDate.getTime() - now;
      if (distance < 0) {
        clearInterval(interval);
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (num: number) => num.toString().padStart(2, '0');
  return <section className={`py-16 px-6 lg:px-8 ${isFinal ? 'bg-white pt-24' : 'bg-peach'}`} data-id="element-53">
      <div className="max-w-[800px] mx-auto text-center" data-id="element-54">
        {isFinal ? <>
            <h2 className="text-3xl md:text-4xl font-extrabold mb-4" data-id="element-55">
              No dejes pasar esta oportunidad
            </h2>
            <p className="text-xl text-dark/70 font-medium mb-8" data-id="element-56">
              El precio sube cuando termine el contador
            </p>
          </> : <>
            <p className="text-sm font-bold uppercase tracking-wider mb-4 bg-white/50 inline-block px-4 py-1 rounded-full" data-id="element-57">
              Oferta de lanzamiento · Precio especial
            </p>
            <h2 className="text-4xl md:text-5xl font-extrabold mb-2" data-id="element-58">
              +$8.000 DESPUÉS
            </h2>
            <p className="text-xl font-medium mb-8" data-id="element-59">
              El precio sube cuando termine el contador
            </p>
          </>}

        <div className="flex justify-center gap-4 md:gap-6 mb-6" data-id="element-60">
          <TimeUnit value={pad(timeLeft.days)} label="Días" data-id="element-61" />
          <span className="text-3xl md:text-5xl font-bold mt-2 md:mt-4" data-id="element-62">:</span>
          <TimeUnit value={pad(timeLeft.hours)} label="Horas" data-id="element-63" />
          <span className="text-3xl md:text-5xl font-bold mt-2 md:mt-4" data-id="element-64">:</span>
          <TimeUnit value={pad(timeLeft.minutes)} label="Min" data-id="element-65" />
          <span className="text-3xl md:text-5xl font-bold mt-2 md:mt-4" data-id="element-66">:</span>
          <TimeUnit value={pad(timeLeft.seconds)} label="Seg" data-id="element-67" />
        </div>

        {!isFinal && <p className="text-lg font-bold text-dark/60 uppercase tracking-widest" data-id="element-68">
            Y no vuelve a bajar
          </p>}
      </div>
    </section>;
}
function TimeUnit({
  value,
  label
}: {
  value: string;
  label: string;
}) {
  return <div className="flex flex-col items-center" data-id="element-69">
      <div className="bg-white text-dark text-3xl md:text-5xl font-extrabold w-16 h-16 md:w-24 md:h-24 flex items-center justify-center rounded-xl shadow-sm border border-border mb-2" data-id="element-70">
        {value}
      </div>
      <span className="text-xs md:text-sm font-bold uppercase text-dark/70" data-id="element-71">
        {label}
      </span>
    </div>;
}